module.exports = __webpack_public_path__ + "static/media/register-property-landed-terrace-serviceResidential.ee054cbd.png";